// components/projects/ProjectSkeleton.tsx
import { motion } from 'framer-motion';

interface ProjectSkeletonProps {
  count?: number;
}

export const ProjectSkeleton = ({ count = 3 }: ProjectSkeletonProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.1 }}
          className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6"
        >
          <div className="space-y-3">
            {/* Image skeleton */}
            <div className="w-full h-48 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse" />

            {/* Title skeleton */}
            <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-md w-3/4 animate-pulse" />

            {/* Description skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md w-full animate-pulse" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md w-5/6 animate-pulse" />
            </div>

            {/* Tags skeleton */}
            <div className="flex gap-2">
              <div className="h-6 w-16 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse" />
              <div className="h-6 w-16 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};
